import { styled } from "styled-components";

export const ProductNameInfo = styled.span`
  max-width: 100%;
  max-height: 25px;

  text-align: left;
  margin-left: 5px;
`;
